import React from 'react'
import PropTypes from 'prop-types'
import './detail.css'

export default function Detail({ title, value }) {
    return(
        <div className='detail__container'>
            <div className='detail__title'>
                { title }
            </div>
            <div className='detail__value'>
                { value }
            </div>
        </div>
    )
}

Detail.propTypes = {
    title: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
}


// WEBPACK FOOTER //
// ./src/components/Detail/index.js